import { IntegrationAPI } from '@business/api/integration';
import {
  IntegrationId,
  IntegrationResponse,
  IntuitUpdateSettings,
  QBUpdateSettings,
  EncryptionRequest,
  ClickupUpdateSettings,
} from '@business/entities/integration';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap } from 'rxjs/operators';
import { Blocs } from '../tokens';

export class IntegrationBloc extends BaseBloc {
  createIntegration = (data: Partial<IntegrationResponse>) => {
    return IntegrationAPI.createIntegration(data).pipe(
      switchMap(() => resolve(Blocs.settings).fetchSettings()),
      handleMessage({
        type: requestMessage('save_integration'),
      }),
    );
  };

  getEncryptedKey = (data: EncryptionRequest) => {
    return IntegrationAPI.getEncryptedKey(data);
  };

  saveConnection = (data: string) => {
    return IntegrationAPI.saveConnection(data);
  };

  updateQBSettings = (data: QBUpdateSettings) => {
    return IntegrationAPI.updateQBSettings(data).pipe(switchMap(() => resolve(Blocs.settings).fetchSettings()));
  };

  updateClickupSettings = (data: ClickupUpdateSettings) => {
    return IntegrationAPI.updateClickupSettings(data).pipe(switchMap(() => resolve(Blocs.settings).fetchSettings()));
  };

  updateIntuitSettings = (data: IntuitUpdateSettings) => {
    return IntegrationAPI.updateIntuitSettings(data).pipe(switchMap(() => resolve(Blocs.settings).fetchSettings()));
  };

  deleteIntegration = (id: IntegrationId) => {
    return showDeleteConfirmation('Delete Integration', 'Do you really want to remove this integration?').pipe(
      switchMap(() => IntegrationAPI.deleteIntegration(id)),
      switchMap(() => resolve(Blocs.settings).fetchSettings()),
      handleMessage({
        type: requestMessage('delete_integration'),
      }),
    );
  };
}
